module.exports = __webpack_public_path__ + "img/35_43.1e8f1b9e.png";